import React from "react";
import { Outlet } from "react-router-dom";

const OpenLayout = () => {

    return (
        <div className="flex flex-col h-full">
            <Outlet />
        </div>
    );
}

export default OpenLayout;